export default __webpack_public_path__ + "static/media/buildings-active.60659083.png";